import styled from 'styled-components';
import {dFlexColumnCenter} from '../../../../globalVariables/GlobalFlex';

export const header = styled.div`
    flex: none;
    width: 100%;
    ${dFlexColumnCenter}
    gap: var(--space-xs);
    padding: var(--space-sm) var(--space-md);
    border-bottom: 1px dotted var(--color-border-subtle);
`;

export const buyerName = styled.h3`
    font-size: var(--font-size-body-small);
    font-weight: var(--font-weight-bold);
    line-height: 1.2;
    text-align: center;
    word-break: break-word;
`;

export const transactionNo = styled.p`
    font-size: var(--font-size-body-small);
    font-weight: var(--font-weight-regular);
    line-height: 1.2;
    text-align: center;
`;
